import React,{useCallback, useState} from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import { AddDropdown } from '../../../commonComponents/dropdown/AddDropdown'
import { useSelector } from 'react-redux'
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType'
import { TranslateContext } from '../TranslateContext'
import { CommodityField } from '../../../commonComponents/formComponents/CommodityCodeField'
import { useMultipleMerchandiseItem } from '../../hooks/useMultipleMerchandiseItem'

const MerchForm2 = (props)=> {
 
  const { lineItemIndex,invoiceIndex, invoiceId,saveData,updateData,merchandiseId,fieldPattern,validateError } = props
  const [showModal, setShowModal] = useState(false)
  const preferenceList = useSelector((state) => state.DropDownValues?.preferences) || []
  const addEU =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.addEU) || ''
  const addEU1 =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.addEU1) || ''
  const addEU2 =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.addEU2) || ''
  const addNL =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.addNL) || ''
  const prefOrigin =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.prefOrigin) ||''
  const commodity =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.commodity) ||''
  const taricCode = useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.taricCode) || ''

  const addDocCodes = useSelector(state=>state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.additionalDoc)
  ?.filter(itm=>itm?.documentCode)?.map(itm=> itm?.documentCode)

  const {exportCountry,destinationCountry} = useSelector((state) => state.Shipment?.transportation)
  const translate = React.useContext(TranslateContext).translate
  const { isDMS,isImportShipment,serviceType } = useCurrentShipmentType()

  const { lineItem } = fieldPattern({isImportShipment})?.items
  const htsCodeErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_commodity`])
  const { AddItem } = useMultipleMerchandiseItem({tableName: 'additionalDoc',invoiceId,merchandiseId})

  const submit = useCallback((payload) => {
      let {doc,additionalCode1,additionalCode2,description,supUnitType} = payload

      updateData({
        goodsDescription: description,
        weightUoM: supUnitType,
        addEU1: additionalCode1 || additionalCode2,
        addEU2: additionalCode1 ? additionalCode2 : '',
      })

      saveData({
        goodsDescription: description,
        weightUoM: supUnitType,
        addEU1: additionalCode1 || additionalCode2 || '',
        addEU2: additionalCode1 ? additionalCode2 : '',
      })
      let docs = doc?.filter((d)=>d && !addDocCodes?.includes(d)) || []
      docs?.map((doc) => AddItem({ params: { documentCode: doc } }))
    },
    [commodity,addDocCodes]
  )
  const displayCommodity=()=>{
    return (
      <CommodityField
        taricLabel='Taric code'
        htsWidth={!isImportShipment ? '7' : '4'}
        taricWidth={isImportShipment ? 3 : ''}
        htsBoxNumber='6/1'
        taricBoxNumber='6/16'
        translate={translate}
        isFormDisabled={exportCountry && destinationCountry ? false : true}
        serviceType={serviceType}
        isImportShipment={isImportShipment}
        commodityCode={commodity}
        htsCode={commodity}
        errors={htsCodeErr && htsCodeErr?.msg}
        taricCode={taricCode}
        submit={submit}
        invoiceId={invoiceId}
        merchandiseId={merchandiseId}
        showModal={showModal}
        countryOfOrigin={exportCountry}
        destinationCountry={destinationCountry}
        setShowModal={setShowModal}
        onHtsChange={(value) => updateData({ commodity: value, articleNum: ' ' })}
        onTaricChange={(value) => updateData({ taricCode: value, articleNum: ' ' })}
        onHtsPopupChange={({ taricCode, htsCode }) => {
          updateData({ commodity: htsCode, taricCode, articleNum: ' ' })
          saveData({ commodity: htsCode || ' ', taricCode })
          saveData({ articleNum: ' ' })
          const key = `invoice${invoiceIndex + 1}_lineItem${lineItemIndex + 1}_commodity`
          validateError(
            { [key]: '' },
            { [key]: htsCode },
            { [key]: lineItem(invoiceIndex + 1, lineItemIndex + 1)?.commodity }
          )
        }}
        onBlur={() => {
          saveData({ commodity: commodity || ' ', taricCode })
          saveData({ articleNum: ' ' })
          const key = `invoice${invoiceIndex + 1}_lineItem${lineItemIndex + 1}_commodity`
          validateError(
            { [key]: '' },
            { [key]: commodity },
            { [key]: lineItem(invoiceIndex + 1, lineItemIndex + 1)?.commodity }
          )
        }}
      />
    )
  }
  return (
    <React.Fragment>
      {isDMS ? (
        <Grid.Row>
          {displayCommodity()}
          <Grid.Column
            width={!isImportShipment ? '4' : '3'}
            className={`divFormFeild  ${'b-rw-0'}`}
          >
            <AddDropdown
              id={`addeu-${invoiceId}-${merchandiseId}`}
              boxNumber='6/17'
              type='addEU'
              label='ADD EU'
              onSelect={({ value }) => {
                updateData({addEU:value})
                saveData({addEU: value})
              }}
              onBlur={({ value }) => {
                if(!value?.trim()){
                  updateData({addEU:value})
                  saveData({addEU: value || " "})
                }
                
              }}
              selectedValue={addEU}
            />
          </Grid.Column>
          <Grid.Column
            width={!isImportShipment ? '5' : '3'}
            className={`divFormFeild ${isImportShipment && 'b-rw-0'}`}
          >
            <AddDropdown
              id={`addnl-${invoiceId}-${merchandiseId}`}
              boxNumber='6/19'
              type='addNL'
              label='ADD NL'
              onSelect={({ value }) => {
                updateData({addNL:value})
                saveData({addNL: value})
              }}
              onBlur={({ value }) => {
                if(!value?.trim()){
                  updateData({addNL:value})
                  saveData({addNL: value || " "})
                }
              }}
              selectedValue={addNL}
            />
          </Grid.Column>
          {isImportShipment && (
            <Grid.Column width='3' className='divFormFeild'>
              <DropDown
                id={`preference-${invoiceId}-${merchandiseId}`}
                label={translate('PREFERENCE', { ns: ['default', 'lineItem'] })}
                className='field-bg dropdown100 addInfoCode'
                boxNumber='4/18'
                labelClass='text-none'
                isLabel={true}
                mandatory={false}
                direction={'left'}
                data={preferenceList}
                clearable
                value={prefOrigin}
                onChange={(value) => {
                  updateData({prefOrigin:value?.trim()})
                  saveData({prefOrigin:value})
                }}
               
              />
             
            </Grid.Column>
          )}
        </Grid.Row>
      ) : (
        <Grid.Row>
          {displayCommodity()}
          <Grid.Column width={'3'} className="divFormFeild b-rw-0">
            <AddDropdown
              id={`addeu-${invoiceId}-${merchandiseId}`}
              type='addEU'
              label='ADD EU-1'
              onSelect={({ value }) => {
                updateData({addEU1:value})
                saveData({addEU1: value})
              }}
              onBlur={({ value }) => {
                if(!value?.trim()){
                  updateData({addEU1:value})
                  saveData({addEU1: value || " "})
                }
              
              }}
              selectedValue={addEU1}
            />
          </Grid.Column>
          <Grid.Column width={'3'} className="divFormFeild b-rw-0">
            <AddDropdown
              id={`addeu-${invoiceId}-${merchandiseId}`}
              type='addEU'
              label='ADD EU-2'
              onSelect={({ value }) => {
                updateData({addEU2:value})
                saveData({addEU2: value})
              }}
              onBlur={({ value }) => {
                if(!value?.trim()){
                  updateData({addEU2:value})
                  saveData({addEU2: value || " "})
                }
              }}
              selectedValue={addEU2}
            />
          </Grid.Column>
          <Grid.Column
            width={'3'}
            className={`divFormFeild ${isImportShipment && 'b-rw-0'}`}
          >
            <AddDropdown
              id={`addnl-${invoiceId}-${merchandiseId}`}
              type='addNL'
              label='ADD NL'
              onSelect={({ value }) => {
                updateData({addNL:value})
                saveData({addNL: value})
              }}
              onBlur={({ value }) => {
                if(!value?.trim()){
                  updateData({addNL:value})
                  saveData({addNL: value || " "})
                }
              }}
              selectedValue={addNL}
            />
          </Grid.Column>
          {isImportShipment && (
            <Grid.Column width='3' className='divFormFeild'>
              <DropDown
                id={`preference-${invoiceId}-${merchandiseId}`}
                label={translate('PREFERENCE', { ns: ['default', 'lineItem'] })}
                className='field-bg dropdown100 addInfoCode'
                boxNumber='4/18'
                labelClass='text-none'
                isLabel={true}
                mandatory={false}
                direction='left'
                data={preferenceList}
                clearable
                value={prefOrigin}
                onChange={(value) => {
                  updateData({prefOrigin:value?.trim()})
                  saveData({prefOrigin:value})
                }}
               
              />
             
            </Grid.Column>
          )}
        </Grid.Row>
      )}
    </React.Fragment>
  )
}

export default React.memo(MerchForm2)
